import ninegrid from "../index.js";

class nxTab extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        
        this.shadowRoot.innerHTML = `
            <style>
				@import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/nxTab.css";
				${ninegrid.getCustomPath(this,"nxTab.css")}
			</style>

            <div class="tabs"></div>
            <div class="tab-pages"></div>
        `;
        
		//console.log(this.shadowRoot.querySelector('.tab-page'));
		//this.shadowRoot.querySelector('.tab-pages').style.height = this.shadowRoot.querySelector('.tab-page').style.height;
		
        this.switchTabHandler = this.#switchTab.bind(this);


        this.tabpage = {
            show: (v) => {
                this.shadowRoot.querySelectorAll(".tab-button").forEach((el, i) => {
                    if (el.innerText.trim() === v) {
                        el.style.display = "unset";
                    }
                })
            },
            showAll: () => {
                this.shadowRoot.querySelectorAll(".tab-button").forEach((el, i) => {
                    el.style.display = "unset";
                })
            },
            hide: (v) => {
                this.shadowRoot.querySelectorAll(".tab-button").forEach((el, i) => {
                    if (el.innerText.trim() === v) {
                        el.style.display = "none";
                    }
                })
            }
        }
    }



    connectedCallback() {
        this.#init();
        this.dispatchEvent(new CustomEvent(ninegrid.EVENT.TAB_LOAD, { bubbles: true, detail: {} }));
    }

    initialize = () => {
        this.shadowRoot.querySelectorAll(".tab-button").forEach((el, i) => {
           el.classList.remove("active");
        });

        const activeButton = this.shadowRoot.querySelector('.tab-button:not([style*="display: none"])');

        if (activeButton) {
            activeButton.click(); // 자동으로 탭 전환
        }

        /**
        const activeTab = this.shadowRoot.querySelector('.tab-button.active');

        // 현재 탭이 숨겨졌다면 첫 번째 visible 탭으로 이동
        if (activeTab && activeTab.style.display === 'none') {
            const nextVisibleTab = this.shadowRoot.querySelector('.tab-button:not([style*="display: none"])');
            if (nextVisibleTab) {
                nextVisibleTab.click(); // 자동으로 탭 전환
            }
        }*/
    }

    #renderTabs() {
        const tabs = this.shadowRoot.querySelector('.tabs');
        const contents = this.shadowRoot.querySelector('.tab-pages');
        const tabItems = this.querySelectorAll('nx-tab-page');

        tabItems.forEach((item, index) => {
            const tab = document.createElement('div');
            tab.classList.add('tab-button');
            tab.textContent = item.getAttribute('caption');
            tab.setAttribute('data-target', `content${index}`);
            tabs.appendChild(tab);

            const content = document.createElement('div');
            content.id = `content${index}`;
            content.classList.add('tab-page');
            content.innerHTML = item.innerHTML;
            contents.appendChild(content);
        });

        tabItems.forEach((item) => {
            item.remove();
        });
    }

    #switchTab(event) {
        const target = event.target;

        console.log(event);

        if (!target.classList.contains('tab-button')) return;

        const targetId = target.getAttribute('data-target');
        const activeTab = this.shadowRoot.querySelector('.tab-button.active');
        const activeContent = this.shadowRoot.querySelector('.tab-page.active');
        const newContent = this.shadowRoot.getElementById(targetId);

        console.log(targetId, activeTab, activeContent, newContent);

        if (activeTab === target) return; // 현재 탭을 클릭했을 때 아무런 변화가 없도록 함
        console.log("*******");

        if (activeTab && activeContent) {
			activeTab.classList.remove('active');
			activeContent.classList.remove('active','exit-left','exit-right');
			//newContent.classList.remove('exit-left','exit-right');
			activeContent.style.left = '';

			if (activeTab.compareDocumentPosition(target) & Node.DOCUMENT_POSITION_FOLLOWING) {
				activeContent.classList.add('exit-left');
			} else {
				activeContent.classList.add('exit-right');
			}
    //console.log(index);
    //if (index == 1) return;

			newContent.classList.add('active');
			newContent.style.left = '';

			newContent.classList.remove('exit-left','exit-right');
        }
        else if (activeContent && newContent) {
            activeContent.classList.remove('active','exit-left','exit-right');
            //newContent.classList.remove('exit-left','exit-right');
            activeContent.style.left = '';
            activeContent.classList.add('exit-left');

            newContent.classList.add('active');
            newContent.style.left = '';

            newContent.classList.remove('exit-left','exit-right');
        }

        target.classList.add('active');
        //newContent.classList.add('active');
        this.shadowRoot.querySelector('.tab-pages').style.height = `${newContent.scrollHeight}px`;
		
		//console.log(newContent.style.height, newContent.scrollHeight);
    };

    #init = () => {

        this.classList.add(this.getAttribute("theme") || "theme-1");
        this.#renderTabs();
        this.shadowRoot.querySelectorAll('.tab-button').forEach(tab => {
            tab.addEventListener('click', this.switchTabHandler);
        });

        const firstTab = this.shadowRoot.querySelector('.tab-button');
        const firstContent = this.shadowRoot.querySelector('.tab-page');
        if (firstTab && firstContent) {
            firstTab.classList.add('active');
            firstContent.classList.add('active');
            setTimeout(() => {
                this.shadowRoot.querySelector('.tab-pages').style.height = `${firstContent.scrollHeight}px`;
            }, 100);
            //this.shadowRoot.querySelector('.tab-pages').style.height = `${firstContent.scrollHeight}px`;

            console.log(firstContent.style.height, firstContent.scrollHeight);
        }

        this.shadowRoot.querySelectorAll('.tab-page:not(.active)').forEach(el => { el.classList.add('exit-right') });

        const resizeObserver = new ResizeObserver(() => {
            const activeContent = this.shadowRoot.querySelector('.tab-page.active');
            if (activeContent) {
                this.shadowRoot.querySelector('.tab-pages').style.height = `${activeContent.scrollHeight}px`;
            }
        });

        const activeContent = this.shadowRoot.querySelector('.tab-page.active');
        if (activeContent) resizeObserver.observe(activeContent);
    };
}

class nxTabPage extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.caption = this.getAttribute('caption');
    }
}

if (!customElements.get('nx-tab')) {
    customElements.define('nx-tab', nxTab);
}

if (!customElements.get('nx-tab-page')) {
    customElements.define('nx-tab-page', nxTabPage);
}
